import { useTranslation } from 'react-i18next';
import { formatScore } from '../../util/evaluationFormat';
import styles from './EvaluationRating.module.scss';

type Props = {
  rating?: number | null;
  evaluationCount?: number;
};

const EvaluationRating = ({ rating, evaluationCount = 0 }: Props) => {
  const [t] = useTranslation('evaluations');

  if (!evaluationCount || rating === null || rating === undefined) {
    const notRated = t('supplierScore.notRated', 'Inte betygsatt');
    return (
      <span className={styles.notRated} title={notRated} aria-label={notRated}>
        –
      </span>
    );
  }

  // The space only separates score and count in copied text; the flex gap does the visual spacing.
  return (
    <span className={`gray-star ${styles.rating}`}>
      <span>{formatScore(rating)}</span>
      <span className="fa fa-star" aria-hidden="true" />{' '}
      <span className={styles.answers}>
        {t('supplierScore.answerCount', {
          count: evaluationCount,
          defaultValue_one: '{{count}} svar',
          defaultValue_other: '{{count}} svar',
        })}
      </span>
    </span>
  );
};

export default EvaluationRating;
